import React, { useEffect, useState } from 'react';
import '../styles/Snackbar.css';
import { Box } from '@mui/material';

type SnackbarProps = {
  message: string;
  duration?: number;
  onClose?: () => void;
};

const Snackbar: React.FC<SnackbarProps> = ({
  message,
  duration = 3000,
  onClose,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);

    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  return <Box className="snackbar">{message}</Box>;
};

export default Snackbar;
